module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"productMasterSearch":"Search by product master name"},"es":{"productMasterSearch":"Buscar por nombre de product maestro"}}')
  delete Component.options._Ctor
}
